import Example from "../../../../src/pages/components/dropdown/example.js";
import ExampleTwo from "../../../../src/pages/components/dropdown/example2.js";
import ExampleThree from "../../../../src/pages/components/dropdown/example3.js";
import ExampleFour from "../../../../src/pages/components/dropdown/example4.js";
import ExampleFive from "../../../../src/pages/components/dropdown/example5.js";
import ExampleSix from "../../../../src/pages/components/dropdown/example6.js";
import * as React from 'react';
export default {
  Example,
  ExampleTwo,
  ExampleThree,
  ExampleFour,
  ExampleFive,
  ExampleSix,
  React
};